import type { MetricBaseline } from '@vitalai/health-models';
import { trendArrow } from '../services/labels';
import { Sparkline } from './Sparkline';

interface MetricRowProps {
  label: string;
  value: string;
  unit?: string;
  baseline?: MetricBaseline | null;
  series?: number[];
  hideBaseline?: boolean;
}

export function MetricRow({ label, value, unit, baseline, series, hideBaseline = false }: MetricRowProps) {
  return (
    <div className="metric-row">
      <div className="metric-row__top">
        <span className="metric-row__label">{label}</span>
        {series && series.length > 1 && <Sparkline values={series} width={52} height={24} />}
      </div>
      <div className="metric-row__value">
        {value}
        {unit ? <span className="metric-row__unit"> {unit}</span> : null}
      </div>
      {hideBaseline ? null : baseline ? (
        <div className={`metric-row__baseline metric-row__baseline--${baseline.trend}`}>
          <span className="metric-row__baseline-diff">
            {trendArrow(baseline.trend)} {Math.abs(baseline.percentDifference)}%
          </span>
          <span className="metric-row__baseline-context">vs promedio {baseline.window} dias</span>
        </div>
      ) : (
        <div className="metric-row__baseline metric-row__baseline--stable">
          <span className="metric-row__baseline-context">Recopilando baseline personal</span>
        </div>
      )}
    </div>
  );
}
